import React from "react";
import "./footer.scss";
import logo from "../../media/logo.webp";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        {/* <div className="container-logo">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-citraland-surabaya"
          />
        </div> */}
        <div className="container-deskripsi">
          <div className="alamat">
            <h2>Gallery Marketing</h2>
            <h1>SUMMARECON BEKASI</h1>
            <p>Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru</p>
          </div>
          <div className="contact">Hubungi kami : +6289510613901 (Della)</div>
          <div className="containerinformasi">
            <div className="kebijakan">
              <a href="privacy.html">Kebijakan Privasi</a>
            </div>
            &nbsp;&nbsp;
            <div className="syarat">
              <a href="terms.html">Syarat & Ketentuan</a>
            </div>
            &nbsp;&nbsp;
            <div className="about">
              <a href="tentangkami.html">Tentang Kami</a>
            </div>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">
        <span className="power">Powered by : Linktown</span>
        <br />
        <span className="disclaimer">
          Informasi Ini Dikelolah Oleh Marketing Independen, Bukan Merupakan
          Website Resmi Developer. Tujuan Untuk Kegiatan Pemasaran, Membantu
          Memberikan Referensi Informasi Produk Dapat Sewaktu Waktu Sesuai
          Kebijakan Pengembang
        </span>
      </div>
    </div>
  );
};

export default footer;
